import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Star, CheckCircle2, AlertCircle } from "lucide-react";

export function AdminReviews() {
  const [url, setUrl] = useState("");
  const [saved, setSaved] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings").then((r) => { setUrl(r.data.google_review_url || ""); setSaved(r.data.google_review_url || ""); }).catch(() => {}); }, []);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    const fd = new FormData(); fd.append("google_review_url", url.trim());
    try { const r = await api.put("/admin/settings", fd); setSaved(r.data.google_review_url); toast.success(r.data.google_review_url ? "Review link saved — follow-ups are on" : "Review link cleared — follow-ups paused"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };

  return (
    <div className="dg-card rounded-xl p-5" data-testid="admin-reviews">
      <div className="flex items-center gap-2">
        {saved ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <AlertCircle className="w-4 h-4 text-amber-400" />}
        <div className="dg-eyebrow flex items-center gap-1"><Star className="w-3 h-3" /> Google review follow-ups</div>
        <span className="dg-chip ml-auto" data-testid="reviews-status-chip">{saved ? "On · 10am next morning" : "Paused — add link"}</span>
      </div>
      <p className="text-sm text-slate-400 mt-2">The morning after every completed session, the customer gets a thank-you email with a "Leave a Google review" button (and "Something not right? Just reply" so unhappy customers reach you privately).</p>
      <form onSubmit={save} className="mt-4 flex flex-col sm:flex-row gap-2">
        <input className="dg-input flex-1 text-sm" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://g.page/r/…/review" data-testid="review-url-input" />
        <button type="submit" disabled={busy} className="dg-btn-primary rounded-full px-5 py-2 text-sm" data-testid="review-url-save">Save</button>
      </form>
      <p className="text-xs text-slate-500 mt-2">Get the link: Google Business Profile → "Ask for reviews" → copy. Leave empty to pause follow-ups.</p>
    </div>
  );
}
